module.exports = "https://www.gc-pro.gnp.com.mx/74a8bd8d890ca286993c3afc2d5e6806.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cupon.svg
// module id = 8091
// module chunks = 0